import { useContext, useEffect, useMemo, useState } from 'react';
import { DaoList } from './daoComponents/daoList';
import { DaoSearchInput } from './daoComponents/daoSearchInput';
import { DaoVoteWithDetails } from './daoDetailComponents/daoVote';
import { DaoContext, useSnapshotFunctions } from './daoHook.js';
import { useAccount } from 'wagmi';
import { MakeDaoRequest } from './makeDaoRequest';
import { OnEnterScreen } from '../../onEnterScreen';
import 'react-markdown-editor-lite/lib/index.css';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

const MainPage = () => {
  const { toggleProposalForm, refreshDaoList, nextPage } = useSnapshotFunctions();
  const [daoSearch, setDaoSearch] = useState('');
  const { address } = useAccount();
  const { daoData } = useContext(DaoContext);
  const { loaded } = daoData;

  useEffect(() => {
    refreshDaoList(daoSearch);
  }, [address]);

  useEffect(() => {
    if (daoSearch.length > 0) {
      const timeout = setTimeout(() => {
        refreshDaoList(daoSearch);
      }, 500);
      return () => clearTimeout(timeout);
    } else {
      refreshDaoList(daoSearch);
    }
  }, [daoSearch]);

  return (
    <>
      <div className='flex'>
        <span className='text-[24px] font-semibold text-[#000] dark:text-white'>Votes</span>

        {loaded && (
          <button
            onClick={() => {
              toggleProposalForm(true);
            }}
            className='ml-auto rounded-[10px] border border-[#7445FF] bg-accent px-[16px] py-[12px] text-[14px] text-white hover:bg-accent-light'
          >
            + Make a Proposal
          </button>
        )}
      </div>
      {
        <div className='my-5 flex'>
          <DaoSearchInput
            onChange={(val) => {
              setDaoSearch(val);
            }}
          />

          <div className='ml-auto flex'>
            {/*<div className=''>
              <DaoStatusDropdown />
          </div>*/}
            {/*<DaoCreatorSelect />*/}
          </div>
        </div>
      }

      <DaoList />
      <OnEnterScreen
        onVisible={() => {
          nextPage();
        }}
      />
    </>
  );
};

const DaoDetails = () => {
  const { backToProposals } = useSnapshotFunctions();

  return (
    <>
      <button
        className='flex rounded-r-full bg-[#E7E8EC] px-[12px] py-[6px] text-[12px] text-[#666] dark:bg-jacarta-600 dark:text-white'
        onClick={backToProposals}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='9'
          height='14'
          viewBox='0 0 9 14'
          fill='none'
          className='mr-3 mt-[2px]'
        >
          <path
            d='M8.41 11.59L3.83 7L8.41 2.41L7 1L1 7L7 13L8.41 11.59Z'
            fill='#666666'
            className='dark:fill-white'
            stroke='#E7E8EC'
            strokeWidth='0.5'
          />
        </svg>
        Back to Votes
      </button>

      <DaoVoteWithDetails />
    </>
  );
};

const DaoContainer = () => {
  const { daoData } = useContext(DaoContext);
  const { refreshVotePower, selectProposal } = useSnapshotFunctions();
  const { address } = useAccount();
  const router = useRouter();

  useEffect(() => {
    console.log('daocontainer');
    const searchParams = new URLSearchParams(router.asPath.split(/\?/)[1]);
    console.log(searchParams.get('proposal'));
    searchParams.get('proposal') && selectProposal(searchParams.get('proposal'));
  }, []);

  useEffect(() => {
    refreshVotePower();
  }, [address]);

  const { selectedProposal, proposalFormOpen } = daoData;

  const El = useMemo(() => {
    if (proposalFormOpen) {
      return MakeDaoRequest;
    } else if (selectedProposal) {
      return DaoDetails;
    }
    return MainPage;
  }, [proposalFormOpen, selectedProposal]);

  return (
    <div>
      <El />
    </div>
  );
};

export const CollectionDao = ({ daoEnsName }) => {
  const [daoData, setDaoData] = useState({});

  const value = useMemo(() => {
    return {
      daoData,
      daoEnsName,
      onDaoUpdate: setDaoData,
    };
  }, [daoData, daoEnsName]);

  return (
    <DaoContext.Provider value={value}>
      <DaoContainer />
    </DaoContext.Provider>
  );
};

CollectionDao.propTypes = {
  daoEnsName: PropTypes.string,
};
